import ExcelJS, { Workbook } from "exceljs";
import { saveAs } from "file-saver";
import { getLanguage } from "helpers/translations";
import { getLocationItemData } from "./location/location-item-column";
import { excelSheetLocation } from "./sheet/excel-sheet-location";
import { LocationData } from "helpers/models";

export const downloadItem = async (
  propData: any[],
  location: LocationData,
  t: any
) => {
  if (!propData) {
    return;
  }

  const language = getLanguage();
  const templateUrl =
    language === "en"
      ? `/template/import/location-set-import-template.xlsx`
      : `/template/import/地点集导入模版.xlsx`;
  const response = await fetch(templateUrl + `?_=${new Date().getTime()}`);
  const templateBlob = await response.blob();
  const templateArray = await new Promise<Uint8Array>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(new Uint8Array(reader.result as ArrayBuffer));
    reader.onerror = reject;
    reader.readAsArrayBuffer(templateBlob);
  });
  const workbook: Workbook = new ExcelJS.Workbook();

  await workbook.xlsx.load(templateArray);

  excelSheetLocation(workbook, location);

  const worksheet = workbook.getWorksheet(2);
  if (!worksheet) {
    return;
  }

  const data = getLocationItemData(propData, t);
  // worksheet.addRows(data);

  // 计算从第二行开始需要删除的行数
  // 确保行数大于1，避免负数
  const rowsToDelete = worksheet.rowCount >= 2 ? worksheet.rowCount - 1 : 0;

  // 从第二行开始，删除所有旧行，并插入新数据
  worksheet.spliceRows(2, rowsToDelete, ...data);

  const buf = await workbook.xlsx.writeBuffer();

  saveAs(
    new Blob([buf], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }),
    `${location?.name || "download"}.xlsx`
  );
};
